import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-search")
class Search extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <div class="${style.search}">
        <input class="${style.search__input}" placeholder="Digite o nome do aluno" type="search" /> 
        <img 
          class="${style.search__img}"
          src="//donna.sistemadulino.com.br/search.svg"
          loading="eager" 
          alt="Procurar" 
        />
        <button class="${style.search__button}">Procurar</button>
      </div>
    `;
  }

  @on.click("button")
  [trait.click]() {
    const value = this.shadowRoot.querySelector("input").value;
    window.dispatchEvent(new CustomEvent("search", { detail: { value } }));

    return this;
  }
}

export default Search;
